import "../assets/css/pages/login.css"
import world from "../assets/images/world.webp";
import logo from "../assets/images/logoProdensa.png";
import close from "../assets/images/close.svg";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Modal, Row } from "react-bootstrap";

import axios from "axios"
import Swal from "sweetalert2";
import { useCookies } from "react-cookie";
import SelectProfile from "./selectProfile.jsx"
import { useAuth } from "../context/auth-user.jsx";

const {
	REACT_APP_URI_AUTHENTIFICATE: URI,
	REACT_APP_URI_RESET_PASSWORD: URI_RESET,
	REACT_APP_URI_AUTHENTIFICATE_WITH_TOKEN: URI_USER_TOKEN
} = process.env

function LoginForgetPassword(props) {
	const [emailToReset, setEmailToReset] = useState("")

	const resetPassword = () => {
		Swal.fire({
			footer: 'Loading, please wait',
			showConfirmButton: false,
			allowOutsideClick: false,
			allowEscapeKey: false,
			didOpen: () => {
				Swal.showLoading()
			},
		})

		axios.put(URI_RESET, {
			email: emailToReset,
		}).then(response => {
			if (response.data.founded) {
				Swal.fire({
					icon: 'success',
					text: 'Password successfully reset',
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				})
			} else {
				Swal.fire({
					icon: 'error',
					text: "Email doesn't exist",
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				})
			}

			setEmailToReset("")
			props.onHide()
		}).catch(err => {
			console.log("Error al resetear la contraseña: " + err)
			Swal.fire({
				icon: 'error',
				text: 'Error when resetting password',
				showConfirmButton: false,
				timer: 5000,
				timerProgressBar: true,
			})
		})
	}

	return (
		<Modal
			className="forgottenPassword"
			{...props}
			size="md"
			centered
		>
			<Modal.Body>
				<img src={close} alt="Prodensa Supplier" onClick={() => props.onHide()} />
				<h4 className="title">Reset password</h4>
				<div className="inputContainer">
					<input type="text" placeholder="contact@companyinc.com" value={emailToReset}
						onChange={(e) => setEmailToReset(e.target.value)} />
				</div>
				<div className="actions">
					<button onClick={() => props.onHide()}>Cancel</button>
					<button onClick={() => resetPassword()}>Reset</button>
				</div>
			</Modal.Body>
		</Modal>
	);
}

function Login() {
	const [cookie, setCookie, removeCookie] = useCookies(null)

	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");

	const [showPassword, setShowPassword] = useState(false);
	const [showTooltip, setShowTooltip] = useState(false);

	const [modalShow, setModalShow] = useState(false)

	const navigate = useNavigate();
	const { user, updateUser } = useAuth()

	useEffect(() => {
		if (cookie.token && !user.selectedProfile) {
			Swal.fire({
				footer: 'Loading, please wait',
				showConfirmButton: false,
				allowOutsideClick: false,
				allowEscapeKey: false,
				didOpen: () => {
					Swal.showLoading()
				},
			})

			axios.post(URI_USER_TOKEN, { token: cookie.token }).then(res => {
				if (res.data.authentification) {
					if (res.data.profiles?.length > 1) {
						updateUser({
							tempUser: res.data
						})
	
						return
					}
	
					const profile = res.data?.profiles?.[0]
					
					updateUser({
						selectedProfile: {
							...profile,
							darkLightMode: res.data.darkLightMode,
							username: res.data.username,
							userId: res.data._id
						} 
					})

					navigate("/home")
				} else {
					removeCookie("token")
				}

				Swal.close()
			}).catch(err => {
				console.log(err)
				removeCookie("token")
				Swal.close()
			})
		}
	}, [cookie.token, navigate, removeCookie, updateUser, user.selectedProfile])

	const handleInput = (e) => {
		const { target } = e
		const value = target?.value?.trim()

		if (target.name === "username") {
			setUsername(value)
		} else if(target.name === "password") {
			setPassword(value)
		}
	}

	const selectProfile = (profile) => {
		!cookie.token && setCookie("token", user.tempUser.token, { path: "/", maxAge: 60 * 60 * 24 * 7 })

		updateUser({
			userProfiles: user.tempUser.profiles,
			selectedProfile: {
				...profile,
				darkLightMode: user.tempUser.darkLightMode,
				username: user.tempUser.username,
				userId: user.tempUser._id
			},
			tempUser: null
		})
		
		navigate("/home")
	}
	
	const loginClick = (e) => {
		e.preventDefault();

		Swal.fire({
			footer: 'Loading, please wait',
			showConfirmButton: false,
			allowOutsideClick: false,
			allowEscapeKey: false,
			didOpen: () => {
				Swal.showLoading()
			},
		})

		axios.post(URI, {
			username: username,
			password: password,
		}).then(response => {
			if (response.data.authentification) {
				if (response.data.profiles?.length > 1) {
					updateUser({
						tempUser: response.data
					})

					return
				}

				!cookie.token && setCookie("token", response.data.token, { path: "/", maxAge: 60 * 60 * 24 * 7 })

				const profile = response.data?.profiles?.[0]
				
				updateUser({
					selectedProfile: {
						...profile,
						darkLightMode: response.data?.darkLightMode,
						username: response.data?.username,
						userId: response.data._id
					} 
				})

				navigate("/home")

				Swal.fire({
					icon: 'success',
					text: 'Successful authentication',
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				})
			} else {
				Swal.fire({
					icon: 'error',
					text: 'Username/password incorrect.',
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				})
			}
		}).catch(err => {
			console.log("Error al verificar los datos: " + err)
			Swal.fire({
				icon: 'error',
				text: 'User not found.',
				showConfirmButton: false,
				timer: 5000,
				timerProgressBar: true,
			})
		})
	}

	return (
		<section className="login">
			<div className="container">
				<Row>
					<Col xs={{ span: 10, offset: 1 }} lg={{ span: 3, offset: 8 }}>
						<img className="world" src={world} alt="Prodensa cattenna Portal" />
						<img className="logo" src={logo} alt="Prodensa cattenna Portal" />
						<form onSubmit={(e) => loginClick(e)}>
							<div className="inputContainer">
								<input name="username" value={username} onChange={handleInput} type="text" placeholder="Username" autoComplete="username" />
							</div>
							<div className="inputContainer passwordContainer">
								<input name="password" value={password} onChange={handleInput} type={`${!showPassword ? "password" : "text"}`} placeholder="Password" autoComplete="current-password" />
								<div className={`passwordIcon ${showPassword ? "show" : ""}`} onClick={() => setShowPassword(!showPassword)} onMouseEnter={() => setShowTooltip(!showTooltip)} onMouseLeave={() => setShowTooltip(!showTooltip)} />
								<span className={`passwordTooltip ${showTooltip ? "show" : ""}`}>{showPassword ? "Hide password" : "Show password"}</span>
							</div>
							<button className="loginSubmit">
								Login
							</button>
							<button type="button" className="forgotedPass" onClick={() => setModalShow(true)}>Forgot password?</button>
							<a className="contactUs" href="mailto:cattenna@prodensa.com">Contact Us</a>
						</form>
					</Col>
				</Row>
			</div >

			<SelectProfile 
				selectProfile={selectProfile}
			/>

			<LoginForgetPassword show={modalShow} onHide={() => setModalShow(false)} />
		</section >
	)
}

export default Login;